/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
import GoogleOAuthClass from './GoogleOAuth';
import FacebookOAuthClass from './FacebookOAuth';
var GoogleOAuth = new GoogleOAuthClass();
var FacebookOAuth = new FacebookOAuthClass();
export { GoogleOAuth, FacebookOAuth };
//# sourceMappingURL=index.js.map